export const ADD_STORE = 'APP/ADD_STORE'
export const ADD_STORE_SUCCESS = 'APP/ADD_STORE_SUCCESS'
export const ADD_STORE_ERROR = 'APP/ADD_STORE_ERROR'

export const ADD_STORE_CLEAN_UP = 'APP/ADD_STORE/CLEAN_UP'
